import { createSlice } from "@reduxjs/toolkit";

const initialStockAlertsState = {
  entities: null,
  selectedStockAlerts: null,
  listLoading: false,
  actionsLoading: false,
  message: {
    error: null,
    success: null,
    modalError: null,
  },
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const stockAlertsSlice = createSlice({
  name: "stockAlerts",
  initialState: initialStockAlertsState,
  reducers: {
    selectStockAlerts: (state, action) => {
      const { selectedStockAlerts } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.selectedStockAlerts = selectedStockAlerts;
    },
    resetStockAlerts: (state, action) => {
      state.listLoading = false;
      state.selectedStockAlerts = null;
    },
  },
});
